import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import GetGoalSurveyStatisticsResponse from '../../../Spirit/Admin/Interfaces/Models/StatisticsService/GetGoalSurveyStatisticsResponse';

export default class StatisticsService {
	webApiService: WebApiService;
	GetGoalSurveyStatisticsEvent = new Events<WsResponseModelT<GetGoalSurveyStatisticsResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('StatisticsService', 'GetGoalSurveyStatistics', (res: WsResponseModelT<GetGoalSurveyStatisticsResponse>) => {
			self.GetGoalSurveyStatisticsEvent.trigger(res);
		});
	}
	GetGoalSurveyStatistics() { 	
        this.webApiService.send('StatisticsService', 'GetGoalSurveyStatistics' );
    }
	 // async methods
	async getGoalSurveyStatisticsAsync(): Promise<GetGoalSurveyStatisticsResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetGoalSurveyStatistics.bind(this), this.GetGoalSurveyStatisticsEvent)();
	}
}